/*
 * @Author: your name
 * @Date: 2021-03-09 09:54:28
 * @LastEditTime: 2021-05-28 18:51:48
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \txm-manager-fe\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import * as echarts from 'echarts';
import myplugin from './plugins/myplugin'
import IconSvg from './components/Tools/IconSvg'
import BaseHeader from './components/Tools/BaseHeader'
import BaseChart from './components/Tools/BaseChart'
import './assets/icon/iconfont'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/index.css'
import './assets/icon/iconfont.css'
import 'element-ui/lib/theme-chalk/display.css'

Vue.use(ElementUI, { size: 'small' })
Vue.use(Vueaxios, axios)
Vue.use(echarts)
Vue.use(myplugin)
Vue.component('icon-svg', IconSvg)
Vue.component('base-header', BaseHeader)
Vue.component('base-chart', BaseChart)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
